const part = [
    {
        path: 'member-transaction-list',
        name: 'member-transaction-list',
        meta: {
            icon: 'md-stats',
            title: '收支明细表',
            notCache: false,
            access: ['S', 'I', 'I2'],
            items: [
            ]
        },
        component: () => import('@/view/finance-management/member-transaction/member-transaction-list')
    },
    {
        path: 'member-transaction-sum-list',
        name: 'member-transaction-sum-list',
        meta: {
            icon: 'md-stats',
            title: '收支汇总表',
            notCache: false,
            access: ['S', 'I', 'I2'],
            items: [
            ]
        },
        component: () => import('@/view/finance-management/member-transaction/member-transaction-sum-list')
    }
];

export default part;
